import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor"
import { useState, useEffect } from "react"
import { post } from "../../../helpers/api_helper"

const Spinearea1 = ({
  dataColors,
  plotDates,
  deviceId,
  activeBreather,
  value1,
  value2,
  key
}) => {

  const [plottingData, setPlottingData] = useState({
    BR1_RH: [],
    BR1_TEMP: [],
    BR2_RH: [],
    BR2_TEMP: [],
    BR1_LIFE: [],
    BR2_LIFE: [],
  })

  const [startAndEndValue, setStartAndEndValue] = useState({
    start: new Date().toISOString(),
    end: new Date().toISOString(),
  })

  const plotDetails = async () => {
    if (!deviceId) return

    setStartAndEndValue({
      ...startAndEndValue,
      start: plotDates.start,
      end: plotDates.end,
    })

    const bodyParams = {
      deviceId: deviceId,
      startDate: plotDates.start,
      endDate: plotDates.end,
    }

    try {
      const response1 = await post(
        `/api/v1/dashboard/getGraphDataInRange`,
        bodyParams
      )

      if (response1 && response1.BR1_RH) {
        setPlottingData({
          ...plottingData,
          BR1_RH: response1.BR1_RH,
          BR1_TEMP: response1.BR1_TEMP,
          BR2_RH: response1.BR2_RH,
          BR2_TEMP: response1.BR2_TEMP,
          BR1_LIFE: response1.BR1_LIFE,
          BR2_LIFE: response1.BR2_LIFE,
        })
      }
    } catch (error) {
      console.log("Failed to retrieve graph data", error)
    }
  }

  useEffect(() => {
    plotDetails()
  }, [deviceId, plotDates])

  const spineareaChartColors = getChartColorsArray(dataColors)

  const labelData = []
  const br1Data = []
  const br2Data = []

  plottingData.BR1_LIFE.map(data => {
    let date = new Date(data[1])
    const utcDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(utcDate)
    labelData.push(formattedDate)

    br1Data.push(data[0])
  })
  plottingData.BR2_LIFE.map(data => {
    br2Data.push(data[0])
  })


  const series = [
    {
      name: value1,
      data: br1Data,
    },
    {
      name: value2,
      data: br2Data,
    },
  ]

  const options = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },

    colors: spineareaChartColors,
    xaxis: {
      visible: false,
      type: "datetime",
      categories: labelData,
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  }


  return (
    <div >
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="350"
      />
    </div>
  )
}

export default Spinearea1
